import { RNC_LINKS_RECEIVED, RNC_LINKS_DELETED, RNC_LINKS_UNLOADED } from './types'

export default function rnc(state = [], action = {}){
  switch (action.type) {
    case RNC_LINKS_RECEIVED:
      return {
        ...state,
        links: action.data
      }
    case RNC_LINKS_DELETED:
      return  {
        ...state,
        links: []
      }
    case RNC_LINKS_UNLOADED:
      return {
        ...state,
        links: []
      }
    default:
      return state;
  }
}